<template>
  <div class="micro-single">
    <div class="label">{{ $t('single_value') }}</div> 
    <div class="value">{{ singleValue }}</div>
  </div>
</template>

<script>

export default {
  props: ['data'],

  computed:{
    singleValue(){
      return (this.data.buckets && this.data.buckets[0]?.start) || (this.data.values && this.data.values[0]?.value)
    }
  }
}
</script>

<style lang="stylus" scoped>
.micro-single
  display flex
  flex-direction column
  align-items center
  justify-content: center;
  height 100%
  font-weight normal
  .value 
    font-weight bold
    m-font-size(16,24)
  
</style>
